
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getOrganizationReport",
      resolverType: "query",
      routePath: "/getOrganizationReport",
      httpMethod: "POST",
    });
  